import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

export const useStyles = makeStyles((theme) => ({
  button: {
    background: "#2ea043",
    textTransform: "none",
    color: "var(--white)",
    padding: "5px 16px",
    width: "100%",
    boxShadow: "0 0 transparent, 0 0 transparent",
    borderColor: "rgb(240,246,252,0.1)",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    userSelect: "none",
    border: "1px solid",
    borderRadius: "6px",
    appearance: "none",
    "&:hover": {
      backgroundColor: "var(--green-600)",
    },
  },
  icoButton: {
    backgroundColor: "transparent",
    color: "var(--white)",
    textTransform: "none",
    fontSize: 16,
    borderRadius: "100px",
    "&:hover": {
      background: "var(--blue-light)",
    },
  },
}));

export const AuthContainer = styled.div`
  background: var(--blue-dark-1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const LoginCard = styled.div`
  width: 300px;
  margin: auto 15px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #131419;
  box-shadow: var(--bs-lg);
`;

export const LoginHeader = styled.div`
  padding: 20px 30px;
  background: #131419;
  h1 {
    font-weight: 600;
    font-size: 16px;
    color: var(--white);
    text-transform: none;
  }

  div {
    height: 2px;
    width: 80px;
    background-color: var(--blue);
  }
`;

export const LoginContent = styled.form`
  padding: 20px 30px;
  background: var(--green-dark-1);
`;

export const VerifiedEmailMessage = styled.div`
  padding: 3px 10px;
  margin: 10px;
  background: #2ea043;
  border-radius: 6px;
  position: absolute;
  top: 10px;
  box-shadow: var(--bs-md);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 16px;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid var(--black);
  border-radius: 6px;
  appearance: none;
  & > :first-child {
    margin-right: 10px;
  }
`;

export const ForgotPassText = styled.p`
  cursor: pointer;
  padding: 5px;
  color: var(--blue);
  font-size: 14px;
  font-weight: 600;
  text-align: end;

  :hover {
    color: var(--blue-300);
  }
`;

export const ResetedPassword = styled.div`
  border-radius: 6px;
  border: 1px solid var(--black-750);
  box-shadow: var(--bs-md);
  text-align: center;
  padding: 30px 20px;
  word-spacing: 2px;
  letter-spacing: 21px;
  margin: auto;
  background: var(--green-dark-1);
`;
